import {styled} from '@mui/material';
import {AlertInfo} from 'presentation/components';

export const StyledAlert = styled(AlertInfo.Root)`
	margin: 8px 0 16px;
`;
